function downloadEncodedUri(options: { filename: string; encodedUri: string }) {
  const link = document.createElement("a");

  link.setAttribute("href", options.encodedUri);
  link.setAttribute("download", options.filename);

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

export { downloadEncodedUri };
